/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : ARTICLE SENTIMENT V2 CONFIGURATION GENERAL REACTION COUNTS: STYLES --------------- ++++++++++ */
export default theme => ({
  reactiontooltip: {
    '& .hovertooltip': {
      background: '#000000',
      color: '#FFFFFF',
      borderRadius: pxToEm(6),
      fontSize: pxToEm(10),
      padding: `${pxToEm(4)} ${pxToEm(10)}`
    }
  }
});
